import { Sidebar, SidebarButton, SidebarSpacing, Scrollable } from '@/components/DashboardComponents'
import { Outlet } from 'react-router'
import { SidebarHeaderProvider } from '@/components/DashboardComponents';

export const INTERNAL_USERS = ["IwCSMCVkHvgFpUbQwCvtwDTDQkh1", "92IYCQlM5GfSAHRExW9fAj8CRjV2", "y9s8V9edbwREQXgetKOw60HhmYW2", "se9DtL3P11MHuQx9K1eLqME6ph72", "MMHUldZpmobFiIvWyYAJWfgAcQf1"];

export function InternalLayout() {
  return (
    <>
      <div className="dashboard_container" id="internal_layout">
        <header className="dashboard_topbar">
          <div className="topbar_left">
            <div className="topbar_title">Internal Admin Tools</div>
          </div>
        </header>
        <div className="dashboard_main">
          <SidebarHeaderProvider>
            <Sidebar>
              <SidebarButton icon="chart-bar-stacked" to="/internal/activity-graph" name="Activity Graph"/>
              <SidebarSpacing/>
              <SidebarButton icon="account-multiple-outline" to="/internal/users" name="Users"/>
              <SidebarButton icon="book-open-variant-outline" to="/internal/courses" name="Courses"/>
              <SidebarButton icon="domain" to="/internal/organizations" name="Organizations"/>
              <SidebarSpacing/>
              <SidebarButton icon="email-outline" to="/internal/send-emails" name="Send email tool"/>
            </Sidebar>
            <Scrollable className="dashboard_content" remember={true}>
              <Outlet/>
            </Scrollable>
          </SidebarHeaderProvider>
        </div>
      </div>
    </>
  )
}